import React from "react";
import { BetSlipShare } from "@models";
import { observer } from "mobx-react";
import LinkActiveEventsHOC from "../common/event-offer-groups/LinkActiveEventsHOC";
import Title from "../common/event-offer-groups/components/Title";
import SharedBetSlipOfferItem from "./SharedBetSlipOfferItem";

export default observer(function SharedSlipEventOfferGroups(props: {
	betSlipShare: BetSlipShare;
	groupHasTitle?: boolean;
	titleHasScore?: boolean;
	offersHaveColor?: boolean;
}) {
	const {
		groupHasTitle = false,
		titleHasScore = false,
		offersHaveColor = false,
	} = props;

	return (
		<>
			{props.betSlipShare.groupedOffersByEvent.map((offerGroup) => {
				return (
					<div key={offerGroup[0].eventId} className="bet__item">
						<LinkActiveEventsHOC
							className="bet__team bet__link"
							offer={offerGroup[0]}
						>
							<Title
								offer={offerGroup[0]}
								groupHasTitle={groupHasTitle}
								titleHasScore={titleHasScore}
							/>

							{offerGroup.map((offer) => {
								return (
									<SharedBetSlipOfferItem
										key={offer.id}
										offer={offer}
										groupHasTitle={groupHasTitle}
										offersHaveColor={offersHaveColor}
										isSystem={
											props.betSlipShare
												.betSlipCombinations?.length > 1
										}
									/>
								);
							})}
						</LinkActiveEventsHOC>
					</div>
				);
			})}
		</>
	);
});
